import React from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormProvider, TextField } from 'components/Form';
import { Button, Stack, Typography } from '@mui/material';
import { PaperCard } from 'components/Card';
import useYupValidationResolver from 'hook/useYupValidationResolver';
import { forgotPasswordSchema } from '../validation';
import { useAuth } from 'lib/auth';
import { paths } from 'routes';

export const ForgotPasswordForm = () => {
  const { t } = useTranslation();
  const { forgotpassword } = useAuth();
  const [companyEmail, setCompanyEmail] = useState('');
  const [ requested, setRequested ] = useState(false);

  const methods = useForm({
    mode: 'onSubmit',
    resolver: useYupValidationResolver(forgotPasswordSchema),
    values: { companyEmail: companyEmail },
  });

  const onSubmit = async () => {
    try {
      methods.setError(null);
      await forgotpassword(companyEmail);
      setRequested(true);
    } catch (error) {
      methods.setError('companyEmail', { type: 'custom', message: error.message });
    }
  };

  const titleMargin = 3;
  return (
    <>
    {!requested && (
      <PaperCard px={{ xs: 2, sm: 4 }} width={{ xs: 1, sm: 368 }} maxWidth={{ sm: 368 }} sx={{ my: 5 }}>
        <Stack>
          <Typography variant="h5" sx={{ mb: titleMargin, textAlign: "center" }}>
            {t('website:auth.forgotPassword.heading')}
          </Typography>

          <FormProvider methods={methods} onSubmit={onSubmit}>
            <Stack>
              <TextField
                name="companyEmail"
                label={t('website:auth.forgotPassword.emailLabel')}
                placeholder={t('website:auth.forgotPassword.emailPlaceholder')}
                required={true}
                type="email"
                autoComplete="email"
                value={companyEmail}
                onChange={(e) => {
                  setCompanyEmail(e.target.value);
                }}
                sx={{ mb: 2 }}
                fullWidth
              />

              <Button
                size="large"
                type="submit"
                variant="contained"
                color="primary"
                sx={{
                  mt: 2,
                  mb: 0.5,
                  bgcolor: "primary.light",
                  '&:hover': {
                    backgroundColor: "primary.light",
                  },
                }}
              >
                {t('website:auth.forgotPassword.submitButton')}
              </Button>
            </Stack>
          </FormProvider>
        </Stack>
      </PaperCard>
    )}
    {requested && (
      <PaperCard px={{ xs: 2, sm: 4 }} width={{ xs: 1, sm: 368 }} maxWidth={{ sm: 368 }} sx={{ my: 5 }}>
        <Stack>
          <Typography variant="h5" sx={{ mb: titleMargin, textAlign: "center" }}>
            {t('website:auth.forgotPassword.heading')}
          </Typography>

          <Stack sx={{ textAlign: 'center' }}>
            <Typography variant="body1" sx={{ fontWeight: 500 }}>{t('website:auth.forgotPassword.successMessage')}</Typography>
            <Button
              size="large"
              variant="contained"
              color="primary"
              sx={{
                mt: 2,
                mb: 0.5,
                bgcolor: "primary.light",
                '&:hover': {
                  backgroundColor: "primary.light",
                },
              }}
              href={paths.auth.login}
            >
              {t('website:auth.forgotPassword.returnToLogin')}
            </Button>
          </Stack>
        </Stack>
      </PaperCard>
    )}
  </>
  );
};
